var map = {
	"./tile-caas.webp": 970,
	"./tile-chat.webp": 816,
	"./tile-esp32.webp": 667,
	"./tile-file-x.webp": 137,
	"./tile-gymx-website.webp": 95,
	"./tile-hack-the-future.webp": 727,
	"./tile-image-recognition.webp": 157,
	"./tile-retouching-website.webp": 530,
	"./tile-social-app.webp": 923,
	"./tile-tennis-lightning.webp": 778,
	"./tile-training-app.webp": 418,
	"./tile-weather-staton.webp": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 387;